import 'signer-app/authentication/arkose-global.d.ts';

export const loadArkoseCdnScript = (
  publicApiKey: string,
  onArkoseLoad: (e: ArkoseEnforcement) => void,
) => {
  const script = document.createElement('script');
  script.src = `//dropbox-api.arkoselabs.com/v2/${publicApiKey}/api.js`;
  script.async = true;
  script.defer = true;
  window.onArkoseLoad = onArkoseLoad;
  script.setAttribute('data-callback', 'onArkoseLoad');
  document.body.appendChild(script);
};
